<div class="divbox" fxLayoutAlign="center center">
  <mat-card class="box">
    <div>

      <div class="divtitle">
        <mat-card-title class="clstitle">{{titleProject}}</mat-card-title>
      </div>

      <div>
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()">
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'project.label' |transloco}}</mat-label>
              <input matInput type="text" name="name" placeholder="{{'project.label' |transloco}}" [(ngModel)]="name_Input" required maxlength="64">
              <mat-error>
                {{'project.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>{{'project.date' |transloco}}</mat-label>
              <input matInput name="start_date" [matDatepicker]="picker" placeholder="Fecha Inicio (dd/mm/yyyy)" [(ngModel)]="start_date_Input"
                              [readonly]="true" (focus)="picker.open()" required>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="month"></mat-datepicker>
              <mat-error>
                {{'project.errorIncorrect' |transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>{{'project.country' |transloco}}</mat-label>
              <mat-select [(value)]="country_Input" required>
                @for (item of lstCountries; track item) {
                <mat-option [value]="item.viewValue">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'project.errorMandatory' |transloco}}
              </mat-error>
            </mat-form-field>
            
            <mat-form-field class="full-width">
              <mat-label>{{'project.manager' |transloco}}</mat-label>
              <mat-select [(value)]="manager_Selected" name="managers" [formControl]="managersControl" required>
                @for (itemUser of lstUsers; track itemUser) {
                  <mat-option [value]="itemUser.value">{{itemUser.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'project.errorIncorrect' |transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width" *ngIf="storageService.roleId==1">
              <mat-label>{{'project.company' |transloco}}</mat-label>
              <mat-select [(value)]="company_Selected" [formControl]="companyControl"
                                    (selectionChange)="onSelectCompany($event.value)" required>
                @for (item of lstCompanies; track item) {
                  <mat-option [value]="item.value">{{item.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'project.errorIncorrect' |transloco}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
              <mat-label>{{'project.zones' |transloco}}</mat-label>
              <mat-select [(value)]="zones_Selected" name="zones" [formControl]="zonesControl"  multiple>
                @for (itemZone of lstCompanyZones; track itemZone) {
                  <mat-option [value]="itemZone.value">{{itemZone.viewValue}}</mat-option>
                }
              </mat-select>
              <mat-error>
                {{'project.errorIncorrect' |transloco}}
              </mat-error>
            </mat-form-field>

          </mat-card-content>

          <div style="margin-top: 20px;">
            <div class="button-row" fxLayoutAlign="end">
              <button mat-raised-button color="primary" *ngIf="storageService.roleId<3" type="submit">{{'project.save' | transloco}}</button>
              <button mat-raised-button color="warn" *ngIf="!new && storageService.roleId<3" type="button" (click)="onEliminarItm()">{{'project.delete' |transloco}}</button>
              <button mat-raised-button color="basic" routerLink="/projects">{{'project.cancel' |transloco}}</button>
            </div>
          </div>
        </form>

        <!-- Configuración de notificaciones -->
        <div *ngIf="!new" class="notify-config-section">
          <mat-divider class="section-divider"></mat-divider>
          <div class="section-subtitle">Configuración de notificaciones</div>

          <!-- Emails externos -->
          <div class="notif-label">Emails externos</div>
          <div class="add-email-row">
            <mat-form-field class="email-input-field">
              <mat-label>Añadir email</mat-label>
              <input matInput type="email" name="emailToAdd"
                     [(ngModel)]="emailToAdd"
                     (keyup.enter)="addNotificationEmail()"
                     maxlength="128">
            </mat-form-field>
            <button mat-icon-button color="primary" type="button" (click)="addNotificationEmail()">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
          <mat-error *ngIf="invalidEmailToAdd" class="email-error">Email no válido</mat-error>
          <div class="email-list" *ngIf="notificationEmailsList.length > 0">
            <div *ngFor="let em of notificationEmailsList" class="email-tag">
              <mat-icon class="email-tag-icon">email</mat-icon>
              <span class="email-tag-text">{{em.email}}</span>
              <button mat-icon-button type="button" class="email-tag-remove"
                      (click)="removeNotificationEmail(em.id)">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>

          <!-- Usuarios internos a notificar -->
          <div class="notif-label" style="margin-top: 12px;">Usuarios internos a notificar</div>
          <div class="add-email-row">
            <mat-form-field class="email-input-field">
              <mat-label>Añadir usuario</mat-label>
              <mat-select [(ngModel)]="userToAdd" name="prjUserToAdd">
                @for (u of lstUsers; track u) {
                  <mat-option [value]="u.value">{{u.viewValue}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button mat-icon-button color="primary" type="button" (click)="addNotificationUser()">
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
          <div class="email-list" *ngIf="notificationContactsList.length > 0">
            <div *ngFor="let c of notificationContactsList" class="email-tag">
              <mat-icon class="email-tag-icon">person</mat-icon>
              <span class="email-tag-text">{{c.first_name}} {{c.last_name}}</span>
              <button mat-icon-button type="button" class="email-tag-remove"
                      (click)="removeNotificationUser(c.id)">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>

  </div>
  </mat-card>
</div>

<app-dashboard-overview
  *ngIf="!new && companyId && id"
  [companyId]="companyId"
  [projectId]="id"
  [compact]="true">
</app-dashboard-overview>
